////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const consignation = {
	/**
	 * @return {{payload: { Array }, type: string}}
	 * @param {object} filters
	 * @param {object} queryParams
	 */

	postConsignation: (filters = {}, queryParams = { page: '0', size: '250', sort: 'saleOrder.date', nameDir: 'desc' }) => ({
		type: ActionsTypes.POST_CONSIGNATION,
		payload: {
			filters,
			queryParams,
		},
	}),
	postConsignationSuccess: (data) => ({
		type: ActionsTypes.POST_CONSIGNATION_SUCCESS,
		payload: {
			data,
		},
	}),
	postConsignationFailure: () => ({
		type: ActionsTypes.POST_CONSIGNATION_FAILURE,
		payload: {},
	}),

	resetConsignation: () => ({
		type: ActionsTypes.RESET_CONSIGNATION,
	}),

	updateCustomerInfos: (consignation, row, kioskId) => ({
		type: ActionsTypes.UPDATE_CUSTOMER_INFOS,
		payload: {
			consignation,
			row,
			kioskId,
		},
	}),
	updateCustomerInfosSuccess: (customer) => ({
		type: ActionsTypes.UPDATE_CUSTOMER_INFOS_SUCCESS,
		payload: {
			customer,
		},
	}),
	updateCustomerInfosSuccessFailure: (error) => ({
		type: ActionsTypes.UPDATE_CUSTOMER_INFOS_FAILURE,
		payload: {
			error,
		},
	}),

	sendConsignementContract: (idContract) => ({
		type: ActionsTypes.SEND_CONSIGNEMENT_CONTRACT,
		payload: {
			idContract,
		},
	}),
	sendConsignementContractSuccess: (data) => ({
		type: ActionsTypes.SEND_CONSIGNEMENT_CONTRACT_SUCCESS,
		payload: {
			data,
		},
	}),
	sendConsignementContractFailure: (error) => ({
		type: ActionsTypes.SEND_CONSIGNEMENT_CONTRACT_FAILURE,
		payload: {
			error,
		},
	}),

	getTransactionNumber: (transactionNumber) => ({
		type: ActionsTypes.GET_TRANSACTION_NUMBER,
		payload: {
			transactionNumber,
		},
	}),

	resetTransactionNumber: () => ({
		type: ActionsTypes.RESET_TRANSACTION_NUMBER,
	}),

	viewConsignementContract: (idContract) => ({
		type: ActionsTypes.VIEW_CONSIGNEMENT_CONTRACT,
		payload: {
			idContract,
		},
	}),
	viewConsignementContractSuccess: (data) => ({
		type: ActionsTypes.VIEW_CONSIGNEMENT_CONTRACT_SUCCESS,
		payload: {
			data,
		},
	}),
	viewConsignementContractFailure: (error) => ({
		type: ActionsTypes.VIEW_CONSIGNEMENT_CONTRACT_FAILURE,
		payload: {
			error,
		},
	}),
}

export default consignation
